import React, {useEffect, useState} from "react";
import {FileAttachment} from "../typedefs";
import {platformAPI} from "../../../api/axiosConfig";
import {IconButton} from "../../../features/management-v2/import/inputs";
import {Delete} from "@mui/icons-material";

type FileAttachmentRowProps = {
    id: string;
    onRemove?: (id: string) => void;
}

export function FileAttachmentRow({id, onRemove}: FileAttachmentRowProps) {
    const [fileAttachment, setFileAttachment] = useState<FileAttachment>();

    useEffect(() => {
        platformAPI.get<FileAttachment>(`api/siren/file-attachments/${id}`).then((response) => {
            setFileAttachment(response.data);
        })
    }, [id])

    if (!fileAttachment) {
        return null
    }

    return (
        <div className="grid grid-cols-3 gap-4">
            <div
                className="col-span-2 flex items-center w-full bg-white border-light-grey border-1 rounded-md px-4 py-2"
            >
                {fileAttachment.name} <span className="text-sm ml-2">({fileAttachment.filename})</span>
            </div>
            {onRemove && (
                <div>
                    <IconButton
                        text="Remove"
                        color="orange"
                        icon={<Delete />}
                        onClick={() => onRemove(id)}
                    />
                </div>
            )}
        </div>
    )
}
